<template>
	<div class="main" style="padding-bottom: 100px;">
		<hwk-header type="car"></hwk-header>
		<div class="warp car-main2" v-if="nolist">
			<img src="@/assets/nocar2.png" alt="" />
			<div class="btn pointer" @click="pageTo('goodsList')">去下单</div>
		</div>
		<div class="warp car-main flex">
			<div class="c-l">
				<div class="title">全部商品（{{list.length}}）</div>
				<div class="change flex" @click="changeChecked">
					<img src="@/assets/f2.png" v-if="checked">
					<img src="@/assets/f1.png" v-else>
					<span class="pointer">全选</span>
					<span @click="delCart" class="pointer">删除</span>
				</div>
				<div class="list">
					<div class="item flex" v-for="(item,index) in list" :key="index">
						<div class="l" @click="oneChecked(item)">
							<img src="@/assets/f2.png" v-if="item.checked">
							<img src="@/assets/f1.png" v-else>
						</div>
						<div class="m flex">
							<img :src="http + item.goods.image" alt="" />
							<div class="con flex">
								<div class="cl">
									<div class="t">{{item.goods.title}}</div>
									<div class="p">{{item.goods_child.sku_string}}</div>
									<div class="p">{{item.warehouse.name}}</div>
								</div>
								<div class="cm">￥<b class="num-din">{{item.goods_child.price}}</b></div>
								<div class="cr">
									<el-input-number style="width: 140px;" v-model="item.pay_number"
										@change="handleChange($event,index,item)" :min="1" :max="99999"
										label="描述文字"></el-input-number>
								</div>
							</div>
						</div>
						<div class="r">￥<span><b class="num-din">{{getMoney(item)}}</b></span></div>
					</div>
				</div>
			</div>
			<div class="c-r">
				<div class="title">结算明细</div>
				<div class="empty" v-if="number == 0">
					<img src="@/assets/nocar.png" alt="" />
				</div>
				<div class="datas" v-else>
					<div class="item flex">
						<div class="l">商品数量</div>
						<div class="r1">共<b class="num-din">{{getNumber(list)}}</b>件</div>
					</div>
					<div class="item flex">
						<div class="l">商品总价</div>
						<div class="r2">￥<span><b>{{getTotal(list)}}</b></span></div>
					</div>
				</div>
				<div class="btns flex">
					<div class="btn btn1 pointer" @click="goBack">返回</div>
					<div class="btn btn2 pointer" :class="{on:number>0}" @click="toPay">去结算</div>
				</div>
			</div>
		</div>
		<navigation :cartshow="false"></navigation>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation
		},
		data() {
			return {
				http: this.$imgUrl,
				list: [],
				pageSize: 0,
				page: 1,
				checked: false,
				nolist: false,
				number: 0,
				total: 0
			};
		},
		created() {
			this.getlist();
		},
		computed: {
			getNumber() {
				return (list) => {
					let list2 = this.list.filter(item => item.checked);
					return list2.reduce((acc, curr) => acc + curr.pay_number, 0)
				}
			},
			getMoney() {
				return (data) => {
					let p = parseFloat(data.goods_child.price) * parseInt(data.pay_number)
					return p.toFixed(2)
				}
			},
			getTotal() {
				return (data) => {
					let list = this.list.filter(item => item.checked);
					let p = list.reduce((acc, curr) => acc + parseFloat(curr.goods_child.price) * parseInt(curr
						.pay_number), 0);
					return p.toFixed(2)
				}
			},
		},
		watch: {
			list: {
				handler(newVal, oldVal) {
					console.log('items changed deeply', newVal, oldVal);
				},
				deep: true
			}
		},

		methods: {
			toPay() {
				if (this.number == 0) {
					this.$message({
						message: '至少选一个',
						type: 'warning'
					});
					return
				}
				let list = this.list.filter(item => item.checked);
				let every = list.every(item => item.warehouse_id === list[0].warehouse_id)
				if (!every) {
					this.$message({
						message: '只能选一个仓库内的商品下单',
						type: 'warning'
					});
					return
				}

				localStorage.setItem('myPayCart', JSON.stringify(list));

				this.$router.push({
					path: "/carAddress",
					query: {
						from: 'cart'
					}
				});

			},
			goBack() {
				this.$router.go(-1);
			},
			handleChange(val, index, item) {

				this.$http.post('/api/user_car/add_edit', {
					id: item.id,
					goods_child_id: item.goods_child_id,
					warehouse_id: item.warehouse_id,
					pay_number: val
				}).then(res => {
					if (res.code == 1) {
						this.$message({
							type: 'success',
							message: '修改成功!'
						});
						this.getlist();
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				});
			},
			delCart() {
				let list = this.list.filter(item => item.checked)
				if (list.length == 0) {
					this.$message({
						message: '至少选一个',
						type: 'warning'
					});
					return
				}

				this.$confirm('确认要删除商品吗?', '删除商品', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let ids = list.map(item => item.id).toString()
					this.$http.post('/api/user_car/del', {
						id: ids
					}).then(res => {
						if (res.code == 1) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getlist();
						} else {
							this.$message({
								message: res.msg,
								type: 'error'
							});
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});





			},
			changeChecked() {
				this.checked = !this.checked
				this.list.forEach(item => item.checked = this.checked)
				this.number = this.list.filter(item3 => item3.checked).reduce((acc, curr) => acc + curr.pay_number, 0);
			},
			oneChecked(item) {
				console.log(item, 1111111111)
				item.checked = !item.checked
				this.$forceUpdate()
				this.checked = this.list.every(item2 => item2.checked)
				this.number = this.list.filter(item3 => item3.checked).reduce((acc, curr) => acc + curr.pay_number, 0);
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/details",
					query: {
						id: id
					}
				});
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			getlist() {
				this.$http.get('/api/user_car/index', {

				}).then(res => {
					console.log(3333)
					this.list = res.data.data
					this.nolist = this.list.length == 0
					this.list.forEach(item => item.checked = false)
					let number = res.data.data.length
					localStorage.setItem('cartNumber', number);
					this.$store.dispatch('setCartNumber', number);
				});

			},
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.car-main2 {
		margin-top: 20px;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 250px 0;
		border-radius: 10px;

		img {
			width: 338px;
			height: 246px;
		}

		.btn {
			width: 248px;
			height: 48px;
			background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
			border-radius: 10px;
			line-height: 48px;
			font-weight: bold;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			margin-top: 80px;
		}
	}

	.car-main {
		align-items: flex-start;
		padding: 20px 0;
	}

	.c-l {
		flex: 1;
		width: 1px;
		background-color: #fff;
		padding: 20px;
		border-radius: 10px;
		margin-right: 20px;

		.list {
			margin-top: 10px;

			.item {
				padding: 10px 0;


				.l {
					img {
						width: 16px;
						height: 16px;
						cursor: pointer;
					}
				}

				.m {
					flex: 1;
					width: 1px;
					margin-left: 10px;
					margin-right: 10px;

					img {
						width: 72px;
						height: 72px;
						background: #FFFFFF;
						border-radius: 6px;
						border: 1px solid #D8D8D8;
					}

					.con {
						flex: 1;
						width: 1px;
						margin-left: 10px;
						justify-content: space-between;

						.cl {
							flex: 1;
							width: 1px;

							.t {

								font-weight: 500;
								font-size: 14px;
								color: #11192D;
								line-height: 16px;
								text-align: left;
							}

							.p {

								height: 17px;
								line-height: 17px;
								font-size: 12px;
								color: #50607A;
								text-align: left;
							}
						}

						.cm {

							font-weight: 500;
							font-size: 14px;
							color: #11192D;
							text-align: center;

						}

						.cr {
							width: 140px;
							margin-left: 10px;
						}
					}
				}

				.r {
					font-size: 14px;
					color: @color2;
					width: 120px;
					text-align: right;

					span {
						font-size: 20px;
						font-weight: 600;

					}
				}
			}
		}

		.change {
			display: flex;
			align-items: center;
			height: 30px;
			line-height: 30px;

			img {
				width: 16px;
				height: 16px;
				cursor: pointer;

			}

			span {
				font-size: 14px;
				margin-left: 10px;

				height: 20px;
				line-height: 20px;

				&:hover {
					color: @color2;
				}
			}
		}

		.title {
			text-align: left;
			font-size: 16px;
			color: @color1;
			height: 30px;
			line-height: 30px;
		}
	}

	.c-r {
		width: 370px;
		background: linear-gradient(180deg, #FFF5EE 0%, #FFFFFF 50%);
		border-radius: 10px;
		border: 1px solid #EBEBEB;
		box-sizing: border-box;
		padding: 10px;

		.datas {
			.item {
				height: 40px;
				line-height: 40px;

				.l {

					font-weight: bold;
					font-size: 14px;
					color: #11192D;
					text-align: left;
				}

				.r1 {
					flex: 1;
					width: 1px;
					text-align: right;

					font-weight: 500;
					font-size: 14px;
					color: #11192D;
				}

				.r2 {
					flex: 1;
					width: 1px;
					text-align: right;

					font-weight: 500;
					font-size: 14px;
					color: #11192D;

					span {
						font-size: 20px;
						font-weight: 600;

					}
				}
			}
		}

		.btns {
			margin-top: 30px;
			position: relative;
			padding-top: 20px;
			text-align: center;

			&::after {
				content: '';
				height: 1px;
				background-color: #eee;
				position: absolute;
				top: 0;
				left: -10px;
				right: -10px;
			}

			.btn {
				font-size: 16px;
			}

			.btn1 {
				width: 62px;
				height: 48px;
				line-height: 48px;
				background: #FFFFFF;
				border-radius: 10px;
				border: 1px solid #D8D8D8;
			}

			.btn2 {
				margin-left: 20px;
				width: 250px;
				height: 48px;
				line-height: 48px;
				background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
				border-radius: 10px;
				opacity: 0.5;
				color: #fff;

			}

			.on {

				opacity: 1;
			}
		}

		.title {
			color: @color1;
			font-size: 18px;
			font-weight: 600;
			height: 30px;
			line-height: 30px;
			text-align: left;
		}

		.empty {
			width: 214px;
			height: 156px;
			margin: 60px auto;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}
</style>